/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-01-15 14:04:15
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-10-19 19:33:30
 * @FilePath: \crm-product\found\views\sfa\views\reports\traditional_media_fee\form\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Form, { formCreate } from '@/found/components/form';
import PhotoRespVos from './photo_list.vue';

formCreate.component('PhotoRespVos', PhotoRespVos);

export default {
  name: 'table-component',
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return { formFunctionCode: 'traditional_media_fee_form' };
  },
  methods: {
    formComplete() {
      if (this.formConfig.code === 'view') {
        const tempData = this.formConfig.row;
        this.setValue({
          ...tempData,
          photoRespVos: tempData.metadataVos || [],
        });
        if (tempData && tempData.metadataVos && tempData.metadataVos.length !== 0) {
          this.hiddenFields(false, ['photoRespVos', 'title1']);
        } else {
          this.hiddenFields(true, ['photoRespVos', 'title1']);
        }
      }
    },
    setRule(item) {
      const v = item;
      if (v.field === 'photoRespVos') {
        v.props.value = this.formConfig.row.metadataVos || [];
      }
      return v;
    },
  },

};
